import { render, staticRenderFns } from "./NavItemTree.vue?vue&type=template&id=099cc490&"
import script from "./NavItemTree.vue?vue&type=script&lang=js&"
export * from "./NavItemTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports